import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ image }) => {
  const { type, src, alt } = image;

  return (
    <img className={type || ''} src={src} alt={alt} />
  );
};

Image.propTypes = {
  image: PropTypes.object,
};

export default Image;



// WEBPACK FOOTER //
// ./library/app/components/Content/Image.js